import { useState, useEffect } from "react"

// providers
import { trans } from "@/_providers/Translation"

export default function TaskInfoCustomHeadTabs({ isLandlord }) {
  const [activeTabIndxex, setActiveTabIndex] = useState(0)

  useEffect(() => {
    console.log('TaskInfoCustomHeadTabs isLandlord:', isLandlord)
    setActiveTabIndex(Number(isLandlord) === 1 ? 1 : 0)
  }, [isLandlord])

  return (
    <>
      <ul className="custom-tabs">
        <li
          className={activeTabIndxex === 0 ? "active" : ""}
          onClick={() => setActiveTabIndex(0)}
        >
          {trans("random.clientData")}
        </li>
        <li
          className={activeTabIndxex === 1 ? "active" : ""}
          onClick={() => setActiveTabIndex(1)}
        >
          Данни на хазяина
        </li>
      </ul>
      <input
        type="hidden"
        name="is_landlord"
        value={activeTabIndxex === 1 ? 1 : 0}
      />
    </>
  )
}
